var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2294 23.7285C22.6394 25.3166 20.0758 26.3639 17.6409 26.3639C12.5467 26.3639 8.41699 22.2342 8.41699 17.1399C8.41699 12.0457 12.5467 7.91602 17.6409 7.91602C22.7351 7.91602 26.8648 12.0457 26.8648 17.1399C26.8648 19.3704 25.7677 22.2155 24.2294 23.7285ZM24.2294 23.7285L29.5002 28.9993",
    stroke: "#8F90A6",
    strokeWidth: 1.90225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17C11.5 13.6863 14.1863 11 17.5 11",
    stroke: "#C7C9D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlaceholder);
export default __webpack_public_path__ + "static/media/SearchPlaceholder.31754961c0f43056daca28cc06047d7f.svg";
export { ForwardRef as ReactComponent };